import EmailInput from "../input/EmailInput.tsx";
import PasswordInput from "../input/PasswordInput.tsx";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { RegisterType } from "../../../types/Login.ts";
import FormSubmitButton from "../../core/FormSubmitButton.tsx";
import { useSubmitState } from "../../../hooks/useSubmitState.ts";
import { IconCheck, IconUserPlus } from "@tabler/icons-react";
import { ERROR, ERROR_TEXT, ErrorType } from "../../../types/Error/Errors.ts";
import { ERROR_ICON } from "../../../types/Error/ErrorIcons.tsx";
import { clearSession } from "../../../fetch/const.routes.ts";
import {
  fetchRegister,
  getChallenge,
} from "../../../fetch/fetch.authentication.ts";
import { ROUTE_VERIFY } from "../../../const/routes.ts";
import { AuthContext } from "../../../context/context.authentication.tsx";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import ConfirmInput from "../input/ConfirmInput.tsx";
import { TEXT_ACK_REQUIRED } from "../../../const/text.ts";
import { LOADING_CIRCLE } from "../../core/loading/LoadingCircle.tsx";
import { solveChallenge } from "../../../utils/challenge.ts";

const initButton = (
  <>
    <IconUserPlus />
    Registrieren
  </>
);
const loadingButton = (
  <>
    {LOADING_CIRCLE}
    Einen Moment bitte...
  </>
);
const successButton = (
  <>
    <IconCheck />
    Los geht&#39;s!
  </>
);

const errorButton = (error: ErrorType) => {
  return (
    <>
      {ERROR_ICON[error]}
      {ERROR_TEXT[error]}
    </>
  );
};

const RegisterForm = () => {
  const { startAuth } = useContext(AuthContext);
  const navigate = useNavigate();
  const formState = useForm<RegisterType>({
    mode: "all",
  });
  const submitState = useSubmitState({ initButtonChild: initButton });
  // Eventhandler for when register is pressed
  const handleRegister: SubmitHandler<RegisterType> = async (data) => {
    clearSession();
    submitState.init(loadingButton);
    const challenge = await getChallenge();
    if (!challenge.ok) {
      submitState.fetchFailed(challenge.error, errorButton(challenge.error));
      return;
    }
    const challengeSolved = await solveChallenge(
      challenge.value.challenge,
      challenge.value.difficulty,
    );
    const res = await fetchRegister({
      ...data,
      challenge: challenge.value.challenge,
      nonce: challengeSolved,
    });
    if (!res.ok) {
      submitState.fetchFailed(res.error, errorButton(res.error));
      return;
    }
    if (startAuth(res.value)) submitState.fetchSuccess(successButton);
    else
      submitState.fetchFailed(
        "Die Session konnte nicht begonnen werden",
        errorButton(ERROR.UNDEFINED),
      );

    navigate(ROUTE_VERIFY("validate"));
  };
  return (
    <FormProvider {...formState}>
      <form
        onSubmit={formState.handleSubmit(handleRegister)}
        className="flex flex-col gap-2"
      >
        <EmailInput />
        <PasswordInput autoComplete={"new-password"} />
        <ConfirmInput requiredText={TEXT_ACK_REQUIRED} />
        <FormSubmitButton>{submitState.buttonChild}</FormSubmitButton>
      </form>
    </FormProvider>
  );
};
export default RegisterForm;
